import { t } from "i18next";
import {
    convertToRealNumber,
    getShopVatList,
    resolveTvaFromList,
} from "../shared";
export const INITIAL_CITY_FORM_DATA = {
    codePostal: "",
    city: "",
    minimumAmount: "0",
    shippingCosts: "0",
    tva: "",
    country: "",
};
export const INITIAL_VALIDATION = {
    inputCode: false,
    inputCity: false,
    inputTva: false,
    selectCountry: false,
    isValidationNumber: false,
    isValidationtMinimumAmount: false,
    isNullMinimumAmount: false,
    isDeliveryNull: false,
    isExistingCodePostal: false,
};

export function formatCity(dataLivraison: any) {
    if (!dataLivraison || !Array.isArray(dataLivraison)) {
        return [];
    }

    let data: any[] = [];

    dataLivraison.forEach((element: any) => {
        data.push({
            Department: element.Department,
            CodePostale: element.CodePostale,
            NomVille: element.NomVille,
            MinCommande: element.MinCommande,
            FraisLivraison: element.FraisLivraison,
            idTva: element.idTva, // Use the existing idTva directly like in formatZone
            TauxTva: element.TauxTva,
            detailsVille: `\u001bPG+4260 ${
                element.NomVille
            } \u001bPG-: Frais liv : ${convertToRealNumber(
                element.FraisLivraison
            )} € \u001bPG- - Min CMD : ${convertToRealNumber(
                element.MinCommande
            )} €`,
            InfoVille: `\u001bPG+ ${
                element.NomVille
            } :\u001bPG- (Frais de liv: ${convertToRealNumber(
                element.FraisLivraison
            )} € - Min commande: ${convertToRealNumber(
                element.MinCommande
            )} €)`,
            Pays: element.Pays,
            CodePays: element.codePays,
            SousVille: element.SousVille,
        });
    });

    return data;
}

export function getCountryInfo(cityFormData: any, codeList: any[]) {
    const normalized = cityFormData.country.toLowerCase();
    const countryMap: Record<string, string> = {
        france: "France",
        tunisia: "Tunisie",
        tunisie: "Tunisie",
    };
    const countryLang = countryMap[normalized] || cityFormData.country;
    const codePays = codeList.find(
        (el: any) => countryLang.toLowerCase() === el.pays?.toLowerCase()
    )?.code;

    return { countryLang, codePays };
}

export function createDataVille(
    dataLivraison: any,
    cityFormData: any,
    listcode: any,
    selectedRowShops: any,
    franchiseID: any,
    isUpdate: boolean = false,
    selectedRowsUpdate: any
) {
    const shipping = convertToRealNumber(cityFormData.shippingCosts);
    const minAmount = convertToRealNumber(cityFormData.minimumAmount);
    const tva = resolveTvaFromList(
        cityFormData.tva,
        getShopVatList(selectedRowShops)
    );
    const { countryLang, codePays } = getCountryInfo(cityFormData, listcode);

    let cityDetails = {
        Department: "",
        CodePostale: cityFormData.codePostal,
        NomVille: cityFormData.city,
        MinCommande: cityFormData.minimumAmount,
        FraisLivraison: cityFormData.shippingCosts,
        idTva: tva ? Number(tva.idTva) : 0,
        TauxTva: tva?.tauxTva ?? cityFormData.tva,
        detailsVille: `\u001bPG+4260 ${cityFormData.city} \u001bPG-: Frais liv : ${shipping} € \u001bPG- - Min CMD : ${minAmount} €`,
        InfoVille: `\u001bPG+ ${cityFormData.city} :\u001bPG- (Frais de liv: ${shipping} € - Min commande: ${minAmount} €)`,
        Pays: countryLang,
        CodePays: codePays,
        SousVille: "",
    };

    if (isUpdate) {
        const postalCodeToUpdate =
            selectedRowsUpdate[0][t("Postal code")] ||
            selectedRowsUpdate[0]["Code Postal"];
        dataLivraison = dataLivraison.map((element: any) =>
            element.CodePostale === postalCodeToUpdate
                ? { ...element, ...cityDetails }
                : element
        );
    } else {
        dataLivraison.push(cityDetails);
    }
    dataLivraison = formatCity(dataLivraison);
    let data = {
        shopId: selectedRowShops[0].shopId,
        franchiseID: franchiseID,
        key: "STVilleLivraison",
        data: dataLivraison,
    };
    return data;
}

const isEmpty = (v: any) => v === "" || v === null || v === undefined;

export const validateAndSubmit = (
    cityFormData: any,
    validation: any,
    updateValidation: Function
) => {
    const validationsMap: Record<string, keyof any> = {
        codePostal: "inputCode",
        tva: "inputTva",
        country: "selectCountry",
        city: "inputCity",
        minimumAmount: "isNullMinimumAmount",
        shippingCosts: "isDeliveryNull",
    };
    Object.entries(validationsMap).forEach(([field, key]) => {
        if (isEmpty(cityFormData[field as keyof typeof cityFormData])) {
            updateValidation(key, true);
        }
    });
    const isFormValid =
        !isEmpty(cityFormData.codePostal) &&
        !isEmpty(cityFormData.country) &&
        !isEmpty(cityFormData.tva) &&
        !isEmpty(cityFormData.city) &&
        !isEmpty(cityFormData.minimumAmount) &&
        !isEmpty(cityFormData.shippingCosts) &&
        !validation.isNullMinimumAmount &&
        !validation.inputTva &&
        !validation.isExistingCodePostal &&
        !validation.isValidationtMinimumAmount &&
        !validation.isValidationNumber &&
        !validation.isDeliveryNull;
    return isFormValid;
};

export async function PostCity(
    data: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    try {
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/list/add/city/c&c`;

        const result = await fetchGlobal<any>(apiUrlAdd, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        return result;
    } catch (error) {
        throw error;
    }
}

export function formatCityLivraisonData(cityData: any[]) {
    return (cityData || []).map((el: any) => ({
        Department: el.Department,
        CodePostale: el[t("Postal code")] || el["Code Postal"],
        NomVille: el[t("City")] || el["Ville"],
        MinCommande: el[t("Minimum amount to place an order")],
        FraisLivraison: el[t("Shipping costs")],
        idTva: el.idTva,
        TauxTva: el.Tva,
        detailsVille: el.detailsVille,
        InfoVille: el.InfoVille,
        Pays: el.Pays !== undefined ? el.Pays : el.Country,
        CodePays: el.CodePays,
        SousVille: el.SousVille,
    }));
}
